/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './TabButton.style';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  layoutClass?: string,
  children: string,
};

const useStyles = createUseStyles(styles);

const TabButton = ({ layoutClass, children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor, darkAccentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({
    accentColor,
    darkAccentColor,
    position: 'right',
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classNames(classes.root, layoutClass)}>{children}</div>
  );
};

export default compose(React.memo)(TabButton);
